import axios from 'axios'

const service = axios.create({})

service.interceptors.request.use(
    (config) => {
      if (!config.data) {
        config.headers['Content-Type'] = ''
      }
      return config
    },
    (error) => {
      console.debug(error)
      Promise.reject(error)
    },
  )

export default service
